import type { RSVP } from '@/types';

function getInvitedByValue(r: RSVP): string | undefined {
  if (typeof r.invitedBy !== 'string') {
    return undefined;
  }
  const invitedBy = r.invitedBy.trim();
  return invitedBy.length > 0 ? invitedBy : undefined;
}

function findHostForGuest(guest: RSVP, rsvpList: RSVP[]): RSVP | undefined {
  const invitedByValue = getInvitedByValue(guest);
  if (!invitedByValue) {
    return undefined;
  }

  return rsvpList.find((candidate) => {
    const candidateUserId = typeof candidate.userId === 'string' ? candidate.userId.trim() : '';
    return candidateUserId === invitedByValue || candidate.id === invitedByValue;
  });
}

/** RSVP whose invoice pays for this row (host when guest is covered by inviter). */
export function getPaymentSourceRsvp(rsvp: RSVP, rsvpList: RSVP[]): RSVP {
  const invitedByValue = getInvitedByValue(rsvp);
  const hostRsvp = invitedByValue ? findHostForGuest(rsvp, rsvpList) : undefined;
  return hostRsvp ?? rsvp;
}

/**
 * RSVP row whose invoice document we use (host plus inviter-paid guests, or self-paying guest only).
 */
export function getInvoicePayerRsvp(rsvp: RSVP, rsvpList: RSVP[]): RSVP {
  const invitedByValue = getInvitedByValue(rsvp);
  if (invitedByValue && rsvp.inviterPaysFor === false) {
    return rsvp;
  }
  return getPaymentSourceRsvp(rsvp, rsvpList);
}
